

export type HttpCompressionAlgorithm = "Gzip";
